import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AccessControlService } from './access-control.service';
import { KeywordsAndConstants } from '../../core/keywords-and-constants';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from './theme.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import {
  BehaviorSubject,
  catchError,
  filter,
  finalize,
  Observable,
  of,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Apis } from '../../core/apis';
import { environment } from '../../environments/environment';

var myItem = uuidv4();

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  deviceInfo: any;
  deviceName: String = '';
  uniqueIdentifierId: any;
  deviceUserAgent: any;
  platform: string = '';
  backUpToken: string = '';
  backUpRefreshToken: string = '';

  refreshing = false;
  refreshSubject: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  holdApiCount = 0;
  private holdApiList: string[] = [];

  constructor(
    public constants: KeywordsAndConstants,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _controlService: AccessControlService,
    private _themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (
        localStorage.getItem('uniqueIdentifierId') == '' ||
        localStorage.getItem('uniqueIdentifierId') == null ||
        localStorage.getItem('uniqueIdentifierId') == undefined
      ) {
        localStorage.setItem('uniqueIdentifierId', myItem);
      }
      window.addEventListener('beforeunload', () => {
        if (localStorage.getItem('refreshOnProgress')) {
          localStorage.setItem('refreshOnProgress', 'false');
        }
      });
    }
  }

  getToken() {
    try {
      // if (
      //   localStorage.getItem(this.constants.LocalStorageToken) &&
      //   this.backUpToken != ''
      // ) {
      //   if (
      //     this.backUpToken !=
      //     localStorage.getItem(this.constants.LocalStorageToken)
      //   ) {
      //     console.log('sending the backup token');
      //     return this.backUpToken;
      //   }
      // }
      if (isPlatformBrowser(this.platformId)) {
        const token = localStorage.getItem(this.constants.LocalStorageToken);
        if (!token) {
          return undefined;
        }
        const authToken = JSON.parse(token);
        return authToken;
      }
    } catch (error) {
      return error;
    }
  }

  getRefreshToken() {
    try {
      // if (
      //   localStorage.getItem(this.constants.LocalStorageToken) &&
      //   this.backUpRefreshToken != ''
      // ) {
      //   console.log(
      //     this.backUpRefreshToken,
      //     localStorage.getItem(this.constants.LocalStorageRefreshToken)
      //   );
      //   if (
      //     this.backUpRefreshToken !=
      //     localStorage.getItem(this.constants.LocalStorageRefreshToken)
      //   ) {
      //     console.log('sending the backup refresh token');
      //     return this.backUpRefreshToken;
      //   }
      // }
      if (isPlatformBrowser(this.platformId)) {
        const refreshtoken = localStorage.getItem(
          this.constants.LocalStorageRefreshToken
        );
        if (!refreshtoken) {
          return undefined;
        }
        const authrefreshToken = JSON.parse(refreshtoken);
        return authrefreshToken;
      }
    } catch (error) {
      return error;
    }
  }

  deviceInformation() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (isPlatformBrowser(this.platformId)) {
      this.uniqueIdentifierId = localStorage.getItem('uniqueIdentifierId');
    }
    this.deviceUserAgent = this.deviceInfo.userAgent;
    switch (this.deviceInfo.deviceType) {
      case 'desktop': {
        if (this.deviceInfo.os == 'Windows') {
          this.deviceInfo.browser = 'WINDOWS_DESKTOP';
          this.platform = 'WINDOWS_DESKTOP';
        } else {
          this.deviceInfo.browser = 'MAC';
          this.platform = 'MAC';
        }
        break;
      }
      case 'mobile': {
        if (this.deviceInfo.os == 'Android') {
          this.deviceInfo.browser = 'ANDROID';
          this.platform = 'ANDROID';
        } else {
          this.deviceInfo.browser = 'IOS';
          this.platform = 'IOS';
        }
        break;
      }
      default: {
      }
    }
  }

  getTheme(forceGetFromServer: boolean = false) {
    let themeData: any = localStorage.getItem('themeColors');
    if (!forceGetFromServer && themeData) {
      this._themeService.setTheme(JSON.parse(themeData));
    } else {
      if (isPlatformBrowser(this.platformId)) {
        const hostname = window.location.hostname;
        this._themeService.getUserLogoUrlAndColorCode().subscribe();
      }
    }
  }

  /** Check if JWT expired */
  isTokenExpired(token: string | null): boolean {
    if (!token) return true;
    try {
      const expTimeStamp = Number(
        new JwtHelperService().decodeToken(token).exp
      );
      const currentTimeStamp = Number(
        new Date().getTime().toString().slice(0, 10)
      );
      const res = Number(expTimeStamp) - Number(currentTimeStamp);
      return res < 5;
    } catch (e) {
      return true;
    }
  }

  refreshToken(url: any): Observable<string> {
    if (!this.getRefreshToken()) {
      return throwError(() => 'No refresh token available');
    }
    const isRefreshing = localStorage.getItem('refreshOnProgress');
    if (!this.refreshing && (!isRefreshing || isRefreshing === 'false')) {
      this.refreshing = true;
      localStorage.setItem('refreshOnProgress', 'true');
      this.refreshSubject.next(null);
      return this.http
        .get(Apis.refreshToken, {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': environment.allowed_origin,
            Authorization: `Bearer ${this.getRefreshToken()}`,
          }),
        })
        .pipe(
          tap((refreshTokenResponse: any) => {
            if (refreshTokenResponse) {
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem(
                  this.constants.LocalStorageToken,
                  JSON.stringify(refreshTokenResponse.token)
                );
                localStorage.setItem(
                  this.constants.LocalStorageRefreshToken,
                  JSON.stringify(refreshTokenResponse.refreshToken)
                );
                this.backUpToken = JSON.stringify(refreshTokenResponse.token);
                this.backUpRefreshToken = JSON.stringify(
                  refreshTokenResponse.refreshToken
                );

                const helper = new JwtHelperService();
                const decodedToken = helper.decodeToken(
                  refreshTokenResponse.token
                );
                localStorage.setItem(
                  this.constants.isLoginType,
                  decodedToken.type
                );
              }

              this.refreshSubject.next(refreshTokenResponse.token);

              // this.refreshSubject.complete();

              // this.refreshSubject = new BehaviorSubject<string | null>(null);
            }
            // this.refreshing = false;
            // localStorage.setItem('refreshOnProgress', 'false');
          }),
          switchMap((refreshTokenResponse: any) =>
            of(refreshTokenResponse.token)
          ),
          catchError((err) => {
            // this.refreshing = false;
            // localStorage.setItem('refreshOnProgress', 'false');
            this.refreshSubject.error(err);
            // this.refreshSubject = new BehaviorSubject<string | null>(null);
            // this.refreshSubject.next(null);
            return throwError(() => err);
          }),
          finalize(() => {
            this.refreshing = false;
            localStorage.setItem('refreshOnProgress', 'false');
            this.refreshSubject = new BehaviorSubject<string | null>(null);
          })
        );
    } else {
      // return this.refreshSubject.pipe(
      //   filter((token) => token != null),
      //   take(1)
      // );

      this.incrementHoldApi(url);
      return this.refreshSubject.pipe(
        filter((token) => token != null),
        take(1),
        finalize(() => this.decrementHoldApi(url))
      );
    }
  }

  getHoldApiCount() {
    return this.holdApiCount;
  }

  getHoldApiList() {
    return this.holdApiList;
  }

  incrementHoldApi(url: string) {
    this.holdApiCount++;
    this.holdApiList.push(url);
  }

  decrementHoldApi(url: string) {
    if (this.holdApiCount > 0) {
      this.holdApiCount--;
    }
    this.holdApiList = this.holdApiList.filter((u) => u !== url);
  }

  clearTokens(): void {
    localStorage.removeItem(this.constants.LocalStorageToken);
    localStorage.removeItem(this.constants.LocalStorageRefreshToken);
  }

  logout() {
    let isAdminLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'ADMIN';
    let isMasterUserLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'MASTER_USER';
    let isCustomerLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'CUSTOMER';
    let isPartnerLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'PARTNER';
    let isAffiliatePartnerLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'AFFILIATE_PARTNER';
    let isSubUserLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'SUB_USER';
    let existingUniqueId = localStorage.getItem('uniqueIdentifierId');
    this.backUpToken = '';
    this.backUpRefreshToken = '';
    this._controlService.CategoryMethod = [];
    this._controlService.byCategoryMethod = null;
    let themeData: any = localStorage.getItem('themeColors');
    let pwaBannerDismissedTime: any = localStorage.getItem(
      'pwaBannerDismissedAt'
    );
    localStorage.clear();
    localStorage.setItem('themeColors', themeData);
    localStorage.setItem('uniqueIdentifierId', existingUniqueId!!);
    localStorage.setItem('pwaBannerDismissedAt', pwaBannerDismissedTime);

    if (isAdminLoggedIn) {
      this.router.navigate(['/admin/login']);
      1;
    } else if (isMasterUserLoggedIn) {
      this.router.navigate(['/master-user/login']);
    } else if (isCustomerLoggedIn) {
      this.router.navigate(['/customer/login']);
    } else if (isPartnerLoggedIn) {
      this.router.navigate(['/partner/login']);
    } else if (isAffiliatePartnerLoggedIn) {
      this.router.navigate(['/affiliate-partner/login']);
    } else if (isSubUserLoggedIn) {
      this.router.navigate(['/sub-user/login']);
    } else {
      this.router.navigate(['']);
    }
  }
}
